(function () {
  'use strict';

  function init() {
    const configEl = document.getElementById('bundle-auto-swap-config');
    if (!configEl) return;

    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    const GROUP_SIZE = config.optionNames.length;
    if (!GROUP_SIZE || !config.bundleVariantId) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const BODY_FLAG = 'kaching-bundle-complete';
    let busy = false;
    let pending = false;
    let timer = null;

    function scheduleCheck() {
      clearTimeout(timer);
      timer = setTimeout(check, 350);
    }

    // --- Kaching Cart tiered promotions bar: visual-only override ---
    // When the bundle is in the cart, the bar must LOOK complete. The bundle
    // product is excluded from Kaching's unlock count on purpose (counting it
    // would stack a real 30% order discount on top of the bundle price), so
    // this only touches the rendered DOM, never Kaching's cart data.

    function updateKachingFlag(cart) {
      const hasBundle = cart.items.some(function (item) {
        return item.product_id === config.bundleProductId;
      });
      document.body.classList.toggle(BODY_FLAG, hasBundle);
      if (hasBundle) patchKachingTierBar();
    }

    function patchKachingTierBar() {
      if (!document.body.classList.contains(BODY_FLAG)) return;
      const bar = document.querySelector('kaching-cart .kaching-cart__tiered-promotions-bar');
      if (!bar) return;
      const text = bar.querySelector('.kaching-cart__tiered-promotions-bar-text');
      if (text && config.kachingCompleteText && text.textContent !== config.kachingCompleteText) {
        text.textContent = config.kachingCompleteText;
      }
      bar.querySelectorAll('.kaching-cart__tiered-promotions-bar-icon').forEach(function (icon) {
        if (icon.textContent.indexOf('🔒') === -1) return;
        const walker = document.createTreeWalker(icon, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (node.nodeValue.indexOf('🔒') !== -1) {
            node.nodeValue = node.nodeValue.split('🔒').join('✅');
          }
        }
      });
    }

    // Kaching (Svelte) re-renders the bar on every cart/state change and
    // overwrites our text/emoji patches, so reapply on DOM mutations. The
    // patch is idempotent: once applied it causes no further mutations.
    // Mutations inside <kaching-cart> also trigger a swap re-check: Kaching
    // mutates the cart through the Storefront GraphQL API (cartLinesUpdate,
    // e.g. changing a line's variant from the drawer) and through a captured
    // pre-patch fetch reference, so its cart operations can bypass the
    // fetch/XHR interception below entirely — but its drawer DOM always
    // re-renders afterwards, which this observer does see.
    new MutationObserver(function (mutations) {
      patchKachingTierBar();
      for (let i = 0; i < mutations.length; i++) {
        const target = mutations[i].target;
        const el = target.nodeType === 1 ? target : target.parentElement;
        if (el && el.closest && el.closest('kaching-cart')) {
          if (!busy) scheduleCheck();
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });

    async function check() {
      if (busy) {
        pending = true;
        return;
      }
      busy = true;
      try {
        const cart = await (await fetch(root + 'cart.js')).json();
        updateKachingFlag(cart);

        // Expand eligible cart lines into individual units (one entry per quantity unit)
        const units = [];
        for (const item of cart.items) {
          if (item.product_id === config.bundleProductId) continue;
          if (item.properties && item.properties._bundle_selection) continue;
          const label = config.labels[String(item.variant_id)];
          if (!label) continue;
          for (let i = 0; i < item.quantity; i++) {
            units.push({ key: item.key, label: label });
          }
        }

        const groups = Math.floor(units.length / GROUP_SIZE);
        if (!groups) return;

        const consumed = units.slice(0, groups * GROUP_SIZE);

        const additions = [];
        for (let g = 0; g < groups; g++) {
          const slice = consumed.slice(g * GROUP_SIZE, (g + 1) * GROUP_SIZE);
          const properties = {};
          slice.forEach(function (unit, i) {
            properties[config.optionNames[i]] = unit.label;
          });
          properties._bundle_selection = slice.map(function (unit) {
            return unit.label;
          }).join(' <> ');
          additions.push({ id: config.bundleVariantId, quantity: 1, properties: properties });
        }

        // Add the bundle first: if this fails the cart is left untouched
        const addResponse = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: additions })
        });
        if (!addResponse.ok) return;

        // Remove the consumed individual units
        const decrements = {};
        consumed.forEach(function (unit) {
          decrements[unit.key] = (decrements[unit.key] || 0) + 1;
        });
        const updates = {};
        for (const item of cart.items) {
          if (decrements[item.key]) {
            updates[item.key] = Math.max(0, item.quantity - decrements[item.key]);
          }
        }
        await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });

        await refreshCartUI();
        // Re-check with the post-swap cart (also refreshes the Kaching flag)
        pending = true;
      } catch (e) {
        // Network error: leave the cart as-is
      } finally {
        busy = false;
        if (pending) {
          pending = false;
          scheduleCheck();
        }
      }
    }

    async function refreshCartUI() {
      if (document.querySelector('cart-items')) {
        window.location.reload();
        return;
      }
      const response = await fetch(root + '?sections=cart-drawer,cart-icon-bubble');
      if (!response.ok) return;
      const sections = await response.json();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && sections['cart-drawer']) {
        drawer.renderContents({ sections: sections });
      } else if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          const inner = doc.querySelector('.shopify-section');
          if (inner) bubble.innerHTML = inner.innerHTML;
        }
      }
    }

    const CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?/;

    function isCartGraphqlMutation(url, init) {
      if (url.indexOf('graphql') === -1) return false;
      const body = init && typeof init.body === 'string' ? init.body : '';
      return body.indexOf('cartLines') !== -1;
    }

    const originalFetch = window.fetch;
    window.fetch = function () {
      const result = originalFetch.apply(this, arguments);
      try {
        const target = arguments[0];
        const url = typeof target === 'string' ? target : (target && target.url) || '';
        if (CART_MUTATION.test(url) || isCartGraphqlMutation(url, arguments[1])) {
          result
            .then(function (res) {
              if (res.ok && !busy) scheduleCheck();
            })
            .catch(function () {});
        }
      } catch (e) {
        /* noop */
      }
      return result;
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (typeof url === 'string' && CART_MUTATION.test(url)) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300 && !busy) scheduleCheck();
          });
        }
      } catch (e) {
        /* noop */
      }
      return originalOpen.apply(this, arguments);
    };

    // Covers full page loads: classic form submits, back/forward navigation
    scheduleCheck();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
